module.exports = __webpack_public_path__ + "static/img/local.fdd3670e.svg";